<script setup>
import IconLeftArrow from '@/components/icons/IconLeftArrow.vue'
import IconHome from '@/components/icons/IconHome.vue'
import IconSettings from '@/components/icons/IconSettings.vue'

import SettingsWindow from '@/components/SettingsWindow.vue'

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { onClickOutside } from '@vueuse/core'

const router = useRouter()

const settingsOpen = ref(false)
const modalTarget = ref(null)

onClickOutside(modalTarget, () => {
  settingsOpen.value = false
})

function onClick(name) {
  if (settingsOpen.value) {
    return
  }
  if (window.fresco && window.fresco.onRestart) {
    window.fresco.onRestart()
  }

  router.push({ name })
}
</script>

<template>
  <div class="nav-container grid max-h-full h-full">
    <div class="relative">
      <RouterView class="h-full" />
      <div
        class="absolute top-0 left-0 w-full h-full z-50"
        :class="{ hidden: !settingsOpen }"
        ref="modalTarget"
      >
        <SettingsWindow @close="settingsOpen = false" />
      </div>
    </div>
    <footer class="border-t-2 flex justify-between text-xl font-medium px-4 h-[60px]">
      <div class="flex flex-row flex-grow h-full items-center">
        <div
          class="flex items-center h-full pr-4 mr-4 border-r-2"
          v-if="$route.name !== 'home'"
          @click="onClick('home')"
        >
          <IconLeftArrow class="mr-2" />
          <h4>{{ $t('nav.home') }}</h4>
        </div>
        <div class="flex items-center">
          <h4>{{ $t(`nav.${$route.name}`) }}</h4>
        </div>
      </div>
      <div class="flex items-center border-l-2 pl-4 fill-cream">
        <IconHome @click="onClick('attract')"/>
        <div class="w-[2px] bg-cream mx-4 h-[40px]" />
        <IconSettings @click="settingsOpen = !settingsOpen" />
      </div>
    </footer>
  </div>
</template>

<style scoped>
.nav-container {
  grid-template-rows: 1fr 60px;
}
</style>
